import App from './views/App.vue';
import router from './routes';

let app = new Vue({
        data() { 
            return {
                globalMessages: []
            }
        },
        router,
        render: h => h(App),
}).$mount('#app')

AppKit.init(app);

import AkInput from "./widgets/AkInput.vue";
import AkIgnoreCheck from "./widgets/AkIgnoreCheck.vue";

Vue.component('ak-input', AkInput);
Vue.component('ak-ignore-check', AkIgnoreCheck);
